import React from "react";
import { Updater, async, fromJSX, Widget } from "widgets-for-react";
import { InviewProps } from "../blocksState";
import { DossierArticlesBlockLayout } from "./dossierArticlesBlockLayout";
import { DossierArticles, DossierArticlesBlockState } from "./dossierArticlesBlockState";

export type DossierArticlesBlock = {
    index: number
    inview?: InviewProps
    title?: React.ReactNode
    articlesState: DossierArticlesBlockState
}

export const dossierArticlesBlockWidget = (
    block: DossierArticlesBlock
): Widget<Updater<DossierArticlesBlockState>> =>
async<DossierArticles>(block.articlesState, (childDossiers) =>
    fromJSX(() => <DossierArticlesBlockLayout {...block} articles={childDossiers} />)
  )
